import * as THREE from 'three';
import { threeStore } from '../store/threeStore';

export class Mesh extends THREE.Mesh {
  constructor(geometry: THREE.BufferGeometry, material: THREE.Material) {
    super(geometry, material);
  }

  public addToScene() {
    threeStore.getState().rootState.scene.add(this);
    this.children.forEach((child) => {
      threeStore.getState().rootState.scene.add(child);
    });
  }

  public removeFromScene() {
    threeStore.getState().rootState.scene.remove(this);
    this.children.forEach((child) => {
      threeStore.getState().rootState.scene.remove(child);
    });
  }

  public dispose() {
    this.removeFromScene();
    this.geometry.dispose();
  }

  public setVisible(visible: boolean): void {
    this.visible = visible;
    this.children.forEach((child) => {
      child.visible = visible;
    });
  }
}